<template>
  <NuxtLayout
    name="generic"
    :header="data?.header"
    :footer="data?.footer"
  >
    <div v-show="isFormSubmitted">
      <div
        v-if="data"
        id="gated-content"
        :class="{
          'standard-white-layout': data.header == 'standardWhite',
        }"
      >
        <SectionBuilder
          v-if="data.content"
          v-bind="data.content"
          :class="{
            'text-www-color-neutral-medium-dark': true,
            'mt-70px md:mt-120px': data.header == 'standardDark',
            'hero-background': data.header == 'standardWhite',
          }"
        />

        <CtaBannerComponent
          v-if="data.CTABanner?.reference"
          :data="data.CTABanner.reference"
        />
        <SuggestedContent v-if="!data.removeSuggestedContent" />
      </div>
    </div>
    <div v-show="!isFormSubmitted">
      <div
        v-if="data?.useGate"
        id="gated-form"
      >
        <HeroContent
          v-if="data.heroContent"
          v-bind="data.heroContent"
        />
        <section
          :class="{
            'bg-www-color-neutral-very-light': true,
          }"
        >
          <div
            :class="{
              container: true,
            }"
          >
            <div
              :class="{
                'grid grid-cols-12 gap-4': true,
              }"
            >
              <div
                :class="{
                  'col-span-12 md:col-span-7': true,
                }"
              >
                <PortableText
                  v-if="data?.bodyContent?.footerPortableText"
                  :portable-data="data.bodyContent.footerPortableText"
                  :class="{
                    'text-www-color-neutral-medium-dark': true,
                  }"
                />
              </div>
              <div
                :class="{
                  'col-span-12 md:col-span-5': true,
                }"
              >
                <SectionBuilderForm
                  v-if="data?.form"
                  v-bind="data.form"
                  :class="{
                    'mt-8 bg-www-color-white lg:p-30px': true,
                  }"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { SpotlightQueryResult } from '~/sanity/types';

import CtaBannerComponent from '~/components/Organisms/CTABanner/CTABanner.vue';
import { spotlightQuery } from '~/queries/pages/PageSpotlight.query';
import { useHekateEventBus } from '~/composables/useHekateEventBus';

const { path: currentPathname } = useRoute();
const { data } = await useWwwSanityQuery<SpotlightQueryResult>(spotlightQuery, {
  currentPathname,
});

const isFormSubmitted = ref(!data?.value?.useGate);
const { addEventListener } = useHekateEventBus();

onMounted(() => {
  addEventListener('form-successfully-submitted', () => {
    isFormSubmitted.value = true;
  });
});

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage: data.value?.ogImage ?? data.value?.cardImage,
  title: data.value?.htmlTitle || data.value?.title,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  twitterCard: 'summary_large_image',
});
</script>
<style>
.hero-background .background-image-wrapper:first-child {
  padding-top: 85px !important;
}
</style>
